var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-main"},[_c('div',{attrs:{"name":"fade","mode":"out-in"}},[_c('div',{staticClass:"default-view"},[_c('router-view',{staticClass:"operation-view"})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }